var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 20.75C4.91421 20.75 5.25 20.4142 5.25 20L5.25 12C5.25 10.2051 6.70507 8.75 8.5 8.75L18.6893 8.75L15.9697 11.4697C15.6768 11.7626 15.6768 12.2374 15.9697 12.5303C16.2626 12.8232 16.7374 12.8232 17.0303 12.5303L21.0303 8.53033C21.3232 8.23744 21.3232 7.76256 21.0303 7.46967L17.0303 3.46967C16.7374 3.17678 16.2626 3.17678 15.9697 3.46967C15.6768 3.76256 15.6768 4.23744 15.9697 4.53033L18.6893 7.25L8.5 7.25C5.87665 7.25 3.75 9.37665 3.75 12L3.75 20C3.75 20.4142 4.08579 20.75 4.5 20.75Z",
    fill: "#001412"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnShare);
export default __webpack_public_path__ + "static/media/icn_share.12f0c9184b75c3ebc12583e1073a7f94.svg";
export { ForwardRef as ReactComponent };